import { RoleFieldName } from '../../../schema/common/owner-structure';
import { BusinessType } from './data';
export const getBusinessTypeLabel = (businessType) => {
    switch (businessType) {
        case BusinessType.SelfEmployed:
            return "Enskild firma" /* CopySE.BUSINESS_TYPE_SELF_EMPLOYED_LABEL */;
        case BusinessType.LimitedCompany:
            return "Aktiebolag" /* CopySE.BUSINESS_TYPE_LIMITED_COMPANY_LABEL */;
        case BusinessType.Partnership:
            return "Handelsbolag / kommanditbolag" /* CopySE.BUSINESS_TYPE_PARTNERSHIP_LABEL */;
        case BusinessType.NonProfit:
            return "Ideell verksamhet / f\u00F6rening / kommun" /* CopySE.BUSINESS_TYPE_NON_PROFIT_LABEL */;
        default:
            throw new Error(`Unhandled business type: '${businessType}'`);
    }
};
export const createRoleFieldsTitles = (businessType, text) => {
    return {
        roleDirectors: businessType === BusinessType.NonProfit
            ? text('OWNER_STRUCTURE_NON_PROFIT_DIRECTORS_LABEL')
            : text('OWNER_STRUCTURE_LIMITED_COMPANY_DIRECTORS_LABEL'),
        roleAlternativeOwners: businessType === BusinessType.NonProfit
            ? text('OWNER_STRUCTURE_NON_PROFIT_ALTERNATIVE_OWNERS_LABEL')
            : text('OWNER_STRUCTURE_ALTERNATIVE_OWNERS_LABEL'),
        rolePartners: text('OWNER_STRUCTURE_PARTNERS_LABEL'),
        roleBeneficialOwners: text('OWNER_STRUCTURE_BENEFICIAL_OWNERS_LABEL'),
    };
};
export const getLimitedPartnershipRoleLabels = (text) => {
    return {
        [RoleFieldName.roleDirectors]: text('OWNER_STRUCTURE_LIMITED_COMPANY_ROLE_VALUE_DIRECTOR'),
        [RoleFieldName.rolePartners]: text('OWNER_STRUCTURE_ROLE_VALUE_PARTNER'),
        [RoleFieldName.roleBeneficialOwners]: text('OWNER_STRUCTURE_ROLE_VALUE_BENEFICIAL_OWNER'),
        [RoleFieldName.roleAlternativeOwners]: text('OWNER_STRUCTURE_ROLE_VALUE_ALTERNATIVE_OWNER'),
    };
};
export const getNonProfitRoleLabels = (text) => {
    return {
        [RoleFieldName.roleDirectors]: text('OWNER_STRUCTURE_NON_PROFIT_ROLE_VALUE_DIRECTOR'),
        [RoleFieldName.rolePartners]: null,
        [RoleFieldName.roleBeneficialOwners]: null,
        [RoleFieldName.roleAlternativeOwners]: text('OWNER_STRUCTURE_NON_PROFIT_ROLE_VALUE_ALTERNATIVE_OWNER'),
    };
};
export const getLocalizedBusinessTypeValue = (stepData) => {
    if (!stepData.businessType) {
        return '';
    }
    return getBusinessTypeLabel(stepData.businessType);
};
